module.exports = __webpack_public_path__ + "media/bootstrap-icons/plus-circle-fill-be35c808.svg";